module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subject-dist text-dark",
    class: {
      'subject-dist--print-table': _vm.isPrintingTable
    }
  }, [(_vm.noActiveSchoolYears) ? _c('Banner') : _vm._e(), _vm._v(" "), (_vm.isPrintUsers) ? _c('SubjectDistributionPrint', {
    on: {
      "close": _vm.closeIsPrintUsers
    }
  }) : [_c('div', {
    staticClass: "subject-dist__header"
  }, [_c('div', {
    staticClass: "subject-dist__header__left"
  }, [_c('h1', [_vm._v(_vm._s(_vm.i18n[_vm.locale].subjects_for_teachers))]), _vm._v(" "), _c('ChangeSchoolYear', {
    attrs: {
      "whiteTheme": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "subject-dist__header__right"
  }, [(_vm.userCanManageSchool) ? [_c('DDropdown', {
    staticClass: "marg-05-right",
    attrs: {
      "isShowDots": false,
      "isBottomStart": false,
      "propOffset": [0, 8]
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function() {
        return [_c('button', {
          staticClass: "do-bttn do-bttn--menu-button bttn-export",
          attrs: {
            "type": "button"
          }
        }, [_vm._v("\n                " + _vm._s(_vm.i18n[_vm.locale].automatic_scheduling) + " "), _c('span', {
          staticClass: "icon-menu-open"
        })])]
      },
      proxy: true
    }, {
      key: "list",
      fn: function() {
        return [_c('ul', {
          staticClass: "do-bttn--menu-button__list"
        }, [_c('li', {
          on: {
            "click": function($event) {
              _vm.isZenExportModal = true
            }
          }
        }, [_vm._v("\n                  " + _vm._s(_vm.i18n[_vm.locale].transfer_subjects_to_zen) + "\n                ")]), _vm._v(" "), (_vm.theZENToken.length > 0) ? _c('li', [_c('a', {
          staticClass: "zen-auto-schedule-menu__link",
          attrs: {
            "href": _vm.zenUrl,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].go_to_zen))])]) : _vm._e()])]
      },
      proxy: true
    }], null, false, 147009285)
  })] : (_vm.theZENToken.length > 0) ? _c('a', {
    staticClass: "do-bttn",
    attrs: {
      "href": _vm.zenUrl,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].go_to_zen))]) : _vm._e(), _vm._v(" "), _c('Tabs', {
    attrs: {
      "tabs": _vm.viewTabs,
      "selected": _vm.selectedViewTabId
    },
    on: {
      "select": _vm.onSelectView
    }
  })], 2)]), _vm._v(" "), (_vm.isLoading) ? _c('Loader', {
    attrs: {
      "color": "blue"
    }
  }) : _c('div', {
    staticClass: "subject-dist__body"
  }, [_c('div', {
    staticClass: "doTable__users"
  }, [_c('div', {
    staticClass: "doTable__users__header"
  }, [_c('DoFiltersFilter', {
    attrs: {
      "tags": _vm.groupTags,
      "selectedTags": _vm.selectedGroupTags
    },
    on: {
      "select": _vm.toggleGroupTag,
      "clear": _vm.clearSelectedGroupTags
    }
  })], 1), _vm._v(" "), (!_vm.isPoolsDeactivated) ? _c('div', {
    staticClass: "filter pointer"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isShowOnlyTeacherWithTeachingTime),
      expression: "isShowOnlyTeacherWithTeachingTime"
    }],
    attrs: {
      "type": "checkbox",
      "id": "only-teachers-with-teaching_time"
    },
    domProps: {
      "checked": Array.isArray(_vm.isShowOnlyTeacherWithTeachingTime) ? _vm._i(_vm.isShowOnlyTeacherWithTeachingTime, null) > -1 : (_vm.isShowOnlyTeacherWithTeachingTime)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isShowOnlyTeacherWithTeachingTime,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isShowOnlyTeacherWithTeachingTime = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isShowOnlyTeacherWithTeachingTime = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isShowOnlyTeacherWithTeachingTime = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "marg-5-left pointer no-select",
    attrs: {
      "for": "only-teachers-with-teaching_time"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale].only_show_users_with_uv_time) + "\n          ")])]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "d-box users-list"
  }, [_c('li', {
    staticClass: "user-item user-item__header"
  }, [_c('div', {
    staticClass: "user-sorter",
    class: {
      'user-sorter--active': _vm.sortBy === 'name'
    },
    on: {
      "click": function($event) {
        return _vm.setSortBy('name')
      }
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].name) + "\n              "), _c('span', {
    staticClass: "icon-menu-open"
  })]), _vm._v(" "), _c('div', {
    staticClass: "user-sorter",
    class: {
      'user-sorter--active': _vm.sortBy === 'teachingTimeDiff'
    },
    on: {
      "click": function($event) {
        return _vm.setSortBy('teachingTimeDiff')
      }
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].teaching_hours) + " "), _c('span', {
    staticClass: "icon-menu-open"
  })])]), _vm._v(" "), (_vm.sortedUsersFilteredWithTags.length < 1) ? _c('h4', {
    staticClass: "explainer-text"
  }, [_vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale].no_users_matches) + "\n          ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.sortedUsersFilteredWithTags), function(user) {
    return _c('li', {
      key: user.user_calendar_id,
      staticClass: "user-item",
      class: {
        'user-item--is-open': user.id === _vm.activeUserId
      },
      on: {
        "click": function($event) {
          return _vm.setActiveUserId(user.id)
        }
      }
    }, [(user.id !== _vm.activeUserId) ? _c('div', {
      staticClass: "user-item__name"
    }, [_c('div', {
      staticClass: "user-item__name__bttn icon__bg-circle hint--right",
      attrs: {
        "aria-label": _vm.$t('vue2.task_overview.task_and_hour_overview')
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.setTheUserToShowTasks(user)
        }
      }
    }, [_c('svg', {
      staticClass: "icon-chart tw-icon tw-icon--small",
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 24 24"
      }
    }, [_c('path', {
      staticClass: "primary",
      attrs: {
        "d": "M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2zm11 4a1 1 0 0 0-1 1v8a1 1 0 0 0 2 0V8a1 1 0 0 0-1-1z"
      }
    }), _vm._v(" "), _c('path', {
      staticClass: "secondary",
      attrs: {
        "d": "M8 11a1 1 0 0 1 1 1v4a1 1 0 0 1-2 0v-4a1 1 0 0 1 1-1zm4-2a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0v-6a1 1 0 0 1 1-1z"
      }
    })])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(user.name))])]) : _vm._e(), _vm._v(" "), (user.id !== _vm.activeUserId) ? _c('div', [(_vm.userHasAgreements(user.id)) ? _c('span', {
      staticClass: "icon-file-text2"
    }) : _vm._e(), _vm._v("\n              " + _vm._s(_vm.isLessonsPerWeekActive ? _vm.userLessonsPerWeekMap[user.id] : _vm.userTeachingDiffMap[user.id]) + "\n              "), _c('span', {
      staticClass: "icon-arrow-down4"
    })]) : _vm._e(), _vm._v(" "), (user.id === _vm.activeUserId) ? _c('SubjectsDistributionUser', {
      attrs: {
        "activeUserId": _vm.activeUserId,
        "isPoolsDeactivated": _vm.isPoolsDeactivated,
        "showLessonsPerWeek": _vm.isLessonsPerWeekActive
      },
      on: {
        "editSubject": _vm.setEditSubject,
        "editTask": _vm.setEditTask,
        "showUserTasks": _vm.setTheUserToShowTasks,
        "close": _vm.resetActiveUserId
      }
    }) : _vm._e()], 1)
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "subjects-and-tasks"
  }, [(_vm.isTasksNewView) ? _c('SubjectsDistributionTasksFromSubjects') : (_vm.isTasksView) ? _c('SubjectsDistributionTasks') : (_vm.isCampsView) ? _c('SchoolCamps') : [_c('div', {
    staticClass: "subject-dist__header"
  }, [_c('div', {
    staticClass: "subject-dist__header__left"
  }, [_c('DoFiltersPopover', {
    attrs: {
      "selectedCount": _vm.allSelectedFiltersCount
    },
    on: {
      "clearAll": _vm.clearAllFilters
    }
  }, [_c('div', {
    staticClass: "do-filters-popover__item"
  }, [_c('h5', [_vm._v(_vm._s(_vm.i18n[_vm.locale].filter_by_status))]), _vm._v(" "), _vm._l((_vm.subjectStatusFilters), function(statusFilter) {
    return _c('button', {
      key: statusFilter,
      staticClass: "do-filters-popover__quick-filter",
      class: {
        'do-filters-popover__quick-filter--selected': _vm.selectedSubjectStatusFilters.includes(statusFilter)
      },
      on: {
        "click": function($event) {
          return _vm.toggleSelectedSubjectStatusFilters(statusFilter)
        }
      }
    }, [_c('span', {
      staticClass: "icon-checkmark-circle"
    }), _vm._v("\n                    " + _vm._s(statusFilter) + "\n                  ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "do-filters-popover__item"
  }, [_c('h5', [_vm._v(_vm._s(_vm.i18n[_vm.locale].filter_by_grades))]), _vm._v(" "), _c('DoFiltersFilter', {
    attrs: {
      "title": _vm.i18n[_vm.locale]['grades'],
      "tags": _vm.klassTags,
      "selectedTags": _vm.selectedKlassFilters
    },
    on: {
      "select": _vm.toggleKlassTag,
      "clear": _vm.clearSelectedKlassFilters
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "do-filters-popover__item"
  }, [_c('h5', [_vm._v(_vm._s(_vm.i18n[_vm.locale].filter_by_subjects))]), _vm._v(" "), _c('DoFiltersFilter', {
    attrs: {
      "title": _vm.i18n[_vm.locale]['subjects'],
      "tags": _vm.uniqueSubjects,
      "selectedTags": _vm.selectedSubjectFilters
    },
    on: {
      "select": _vm.toggleSelectedSubjectFilters,
      "clear": _vm.clearSelectedSubjectFilters
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "do-filters-popover__item"
  }, [_c('h5', [_vm._v(_vm._s(_vm.i18n[_vm.locale].filter_by_type))]), _vm._v(" "), _c('DoFiltersFilter', {
    attrs: {
      "title": "Type",
      "tags": _vm.uniqueSubjectTypeLabels,
      "selectedTags": _vm.selectedTypeFilters
    },
    on: {
      "select": _vm.toggleSelectedTypeFilters,
      "clear": _vm.clearSelectedTypeFilters
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "do-filters-popover__item"
  }, [_c('h5', [_vm._v(_vm._s(_vm.i18n[_vm.locale].filter_by_persons))]), _vm._v(" "), _c('DoFiltersFilter', {
    attrs: {
      "title": _vm.i18n[_vm.locale]['persons'],
      "tags": _vm.uniquePersons,
      "selectedTags": _vm.selectedPersonFilters
    },
    on: {
      "select": _vm.toggleSelectedPersonFilters,
      "clear": _vm.clearSelectedPersonFilters
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "subject-dist__header__right"
  }, [(_vm.isUpdatingSchoolYear) ? _c('div', {
    staticClass: "do-spinner do-spinner--small"
  }) : _vm._e(), _vm._v(" "), (_vm.isSchoolDanish && _vm.isTableView) ? _c('DDropdown', {
    staticClass: "marg-05-right",
    attrs: {
      "isShowDots": false,
      "isBottomStart": false,
      "propOffset": [0, 8]
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function() {
        return [_c('button', {
          staticClass: "do-bttn do-bttn--menu-button"
        }, [(_vm.isDownloadingExcel) ? _c('span', {
          staticClass: "do-spinner do-spinner--small"
        }) : _c('span', {
          staticClass: "icon-printer3"
        }), _vm._v(" "), _c('span', {
          staticClass: "icon-menu-open"
        })])]
      },
      proxy: true
    }, {
      key: "list",
      fn: function() {
        return [_c('ul', {
          staticClass: "do-bttn--menu-button__list do-bttn--menu-button__list__print"
        }, [_c('li', {
          on: {
            "click": _vm.printTable
          }
        }, [_c('span', {
          staticClass: "icon-printer3"
        }), _vm._v(" Print tabel \n                    ")]), _vm._v(" "), _c('li', {
          on: {
            "click": _vm.asyncLoadXLSXAndDownloadTable
          }
        }, [_c('span', {
          staticClass: "icon-download"
        }), _vm._v(" Download til excel\n                    ")])])]
      },
      proxy: true
    }], null, false, 369774330)
  }) : _vm._e(), _vm._v(" "), (_vm.isSchoolDanish) ? _c('DDropdown', {
    staticClass: "marg-05-right",
    attrs: {
      "isShowDots": false,
      "isBottomStart": false,
      "isCloseOnDropdownClick": false,
      "propOffset": [0, 8]
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function() {
        return [_c('button', {
          staticClass: "do-bttn do-bttn--menu-button"
        }, [_vm._v("Visning "), _c('span', {
          staticClass: "icon-menu-open"
        })])]
      },
      proxy: true
    }, {
      key: "list",
      fn: function() {
        return [_c('ul', {
          staticClass: "do-bttn--menu-button__list"
        }, [_c('li', {
          on: {
            "click": function($event) {
              _vm.viewMode = _vm.viewMode === 'table' ? 'tiles' : 'table'
            }
          }
        }, [_vm._v("\n                      Vis som tabel\n                      "), (_vm.viewMode === 'table') ? _c('span', {
          staticClass: "icon-checkmark-circle"
        }) : _vm._e()]), _vm._v(" "), (_vm.isShowSubjectsRequest) ? _c('li', {
          on: {
            "click": function($event) {
              _vm.showSubjectsRequestInTable = !_vm.showSubjectsRequestInTable
            }
          }
        }, [_vm._v("\n                      Vis fagønsker i tabellen\n                      "), (_vm.showSubjectsRequestInTable) ? _c('span', {
          staticClass: "icon-checkmark-circle"
        }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isTableView) ? _c('li', {
          on: {
            "click": function($event) {
              _vm.showDatesInTable = !_vm.showDatesInTable
            }
          }
        }, [_vm._v("\n                      Vis datoer i tabellen\n                      "), (_vm.showDatesInTable) ? _c('span', {
          staticClass: "icon-checkmark-circle"
        }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('li', {
          on: {
            "click": function($event) {
              _vm.showLessonsPerWeek = !_vm.showLessonsPerWeek
            }
          }
        }, [_vm._v("\n                      Vis i lektioner\n                      "), (_vm.showLessonsPerWeek) ? _c('span', {
          staticClass: "icon-checkmark-circle"
        }) : _vm._e()]), _vm._v(" "), _c('li', {
          on: {
            "click": function($event) {
              _vm.showActivities = !_vm.showActivities
            }
          }
        }, [_vm._v("\n                      Vis aktiviteter i klasserne\n                      "), (_vm.showActivities) ? _c('span', {
          staticClass: "icon-checkmark-circle"
        }) : _vm._e()]), _vm._v(" "), _c('li', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              arrow: true,
              placement: 'left'
            }),
            expression: "{ arrow: true, placement: 'left' }"
          }],
          attrs: {
            "content": "Slå til hvis ressourcetimer ikke skal medregnes i klassens totale timetal"
          },
          on: {
            "click": _vm.toggleDoesRessCount
          }
        }, [_vm._v("\n                      Ikke medregn ressourcetimer\n                      "), (!_vm.doesRessCountInKlassTotalHours) ? _c('span', {
          staticClass: "icon-checkmark-circle"
        }) : _vm._e()])])]
      },
      proxy: true
    }], null, false, 3599190612)
  }) : _vm._e(), _vm._v(" "), (_vm.userCanManageSchool && _vm.isSchoolDanish) ? _c('DoButtonAndDate', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: false,
        placement: 'top'
      }),
      expression: "{\n                  arrow: false,\n                  placement : 'top'\n                }"
    }],
    attrs: {
      "content": "Fag kan ønskes af brugere med rettigheden",
      "selectedDate": _vm.subjectsRequestEndDate
    },
    on: {
      "dateChanged": _vm.onSetSubjectsRequestEndDate
    }
  }) : _vm._e()], 1)]), _vm._v(" "), (_vm.isTableView && _vm.isEditingDates) ? _c('div', {
    staticClass: "bulk-dates-bar"
  }, [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": _vm.toggleSelectAllVisible
    }
  }, [_vm._v("\n              " + _vm._s(_vm.allVisibleSelected ? 'Fravælg alle' : 'Vælg alle') + "\n            ")]), _vm._v(" "), _c('span', {
    staticClass: "bulk-dates-bar__count"
  }, [_vm._v(_vm._s(_vm.selectedSubjectIds.length) + " valgt")]), _vm._v(" "), (_vm.selectedSubjectIds.length > 0) ? [_c('DatePickerRange', {
    attrs: {
      "startdate": _vm.bulkFromDate,
      "enddate": _vm.bulkToDate,
      "minDate": _vm.bulkDateMin,
      "maxDate": _vm.bulkDateMax,
      "maxEndDate": _vm.bulkDateMax,
      "allowSameDate": true
    },
    on: {
      "startchanged": _vm.setBulkFromDate,
      "endchanged": _vm.setBulkToDate
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--loading': _vm.isSavingBulkDates
    },
    attrs: {
      "disabled": _vm.isSavingBulkDates
    },
    on: {
      "click": _vm.saveBulkDates
    }
  }, [_vm._v("\n                Gem\n              ")])] : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "do-bttn bulk-dates-bar__cancel",
    on: {
      "click": _vm.cancelEditDates
    }
  }, [_vm._v("Annuller")])], 2) : _vm._e(), _vm._v(" "), (_vm.isTableView) ? _c('SubjectsDistributionTable', {
    attrs: {
      "doesRessCountInKlassTotalHours": _vm.doesRessCountInKlassTotalHours,
      "subjectDefaultDuration": _vm.subjectDefaultDuration,
      "filteredKlassCals": _vm.filteredKlassCals,
      "showLessonsPerWeek": _vm.showLessonsPerWeek,
      "showTeacherPoolHours": _vm.showTeacherPoolHours,
      "showSubjectsRequest": _vm.showSubjectsRequestInTable && _vm.isShowSubjectsRequest && Object.keys(_vm.subjectsRequestsInHash).length > 0,
      "showDates": _vm.showDatesInTable,
      "isEditingDates": _vm.isEditingDates,
      "selectedSubjectIds": _vm.selectedSubjectIds
    },
    on: {
      "editSubject": _vm.setEditSubject,
      "toggleEditDates": _vm.toggleEditDates,
      "toggleSubjectSelection": _vm.toggleSubjectSelection
    }
  }) : _c('div', {
    staticClass: "doTable"
  }, [(_vm.filteredKlassCals.length < 1) ? _c('h4', {
    staticClass: "explainer-text"
  }, [_vm._v("\n              " + _vm._s(_vm.i18n[_vm.locale].no_klasses_matches) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "doTable__items"
  }, _vm._l((_vm.filteredKlassCals), function(klassCal, idx) {
    return _c('li', {
      key: klassCal.id,
      staticClass: "doTable__klass"
    }, [_c('div', {
      staticClass: "doTable__klass__header"
    }, [_c('div', [_vm._v(_vm._s(klassCal.name))]), _vm._v(" "), _c('div', {
      staticClass: "doTable__klass__header__flex"
    }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale].hours_in_school_year) + ":")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: (klassCal.vHasReductions ? {
          arrow: true,
          animateFill: false,
          animation: 'shift-away',
          zIndex: '999999992',
          boundary: 'window'
        } : {
          trigger: 'manual'
        }),
        expression: "klassCal.vHasReductions ? { arrow: true, animateFill: false, animation: 'shift-away', zIndex: '999999992', boundary: 'window' } : { trigger: 'manual' }"
      }],
      staticClass: "doTable__klass__header__hours",
      attrs: {
        "content": 'inkl. reduktioner'
      }
    }, [_vm._v(_vm._s(klassCal.vTotalHours))])])]), _vm._v(" "), _c('ul', {
      staticClass: "subjects"
    }, _vm._l((klassCal.vSubjects), function(subject) {
      return _c('li', {
        directives: [{
          name: "tippy",
          rawName: "v-tippy",
          value: ({
            arrow: true,
            onShow: function () { return !!subject.vTooltip; }
          }),
          expression: "{\n                  arrow: true,\n                  onShow: () => !!subject.vTooltip\n                }"
        }],
        key: subject.id,
        staticClass: "subjects_subject",
        class: [{
          'subject--has-user': subject.vHasTeachers
        }, {
          'subject--has-room': subject.vHasRooms
        }, {
          'subject--has-request': subject.vRequestedBy.length > 0
        }, {
          'subject--has-other-klass': subject.v_subjectOtherKlasses && subject.v_subjectOtherKlasses.length > 0
        }],
        style: ({
          'background': subject.color
        }),
        attrs: {
          "content": subject.vTooltip
        },
        on: {
          "click": function($event) {
            return _vm.setEditSubject(subject, klassCal.id)
          }
        }
      }, [_vm._v("\n                  " + _vm._s(subject.name) + " (" + _vm._s(_vm.showLessonsPerWeek ? subject.vLessonsPerWeek : subject.vHours) + ") "), (subject.vIsPartiallyDistributed) ? _c('span', {
        staticClass: "do-pill do-pill--yellow subject-remaining"
      }, [_vm._v(_vm._s(_vm.showLessonsPerWeek ? subject.vRemainingLessonsPerWeek : subject.vRemainingHours.toFixed(1)) + " mangler")]) : _vm._e()])
    }), 0)])
  }), 0)])]], 2)])], _vm._v(" "), (_vm.isSubjectModal) ? _c('SubjectForm', {
    attrs: {
      "showModal": _vm.isSubjectModal,
      "editSubject": _vm.editSubject,
      "poolCalendarId": _vm.editSubjectPoolCalendarId,
      "propIsLoading": _vm.isSubjectLoading,
      "allowDanishPreparationFactorUi": true,
      "isShowSubjectsRequest": _vm.isShowSubjectsRequest,
      "subjectsRequestsInHash": _vm.subjectsRequestsInHash,
      "showActivities": _vm.showActivities
    },
    on: {
      "deleteSubject": _vm.deleteSubject,
      "close": _vm.closeModal,
      "updateSubject": _vm.updateSubject,
      "saveAndShowTab": _vm.saveAndShowTab
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "d-modal"
    }
  }, [(_vm.isConfirmDeletion) ? _c('ModalConfirmation', {
    attrs: {
      "showClose": false
    },
    on: {
      "close": function($event) {
        return _vm.$store.commit('setConfirmDeletion', false)
      },
      "confirm": _vm.confirmDelete
    }
  }, [_c('h3', {
    attrs: {
      "slot": "item"
    },
    slot: "item"
  }, [_vm._v(_vm._s(_vm.itemToDelete.name))])]) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "d-modal"
    }
  }, [(_vm.theEditTask) ? _c('DModal', {
    attrs: {
      "showClose": false
    }
  }, [_c('SubjectsDistributionTasksCreate', {
    attrs: {
      "slot": "insertComponent",
      "editTask": _vm.theEditTask
    },
    on: {
      "close": function($event) {
        _vm.theEditTask = null
      }
    },
    slot: "insertComponent"
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.theUserToShowTasks) ? _c('DModal', {
    attrs: {
      "isBgOverlay": true,
      "show-close": false,
      "isPrintable": true
    },
    on: {
      "close": _vm.closeTheUserToShowTasks
    }
  }, [_c('div', {
    staticClass: "user-task__container",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "user-task__container__header no-print"
  }, [_c('h2'), _vm._v(" "), _c('div', {
    staticClass: "icon__bg-circle ww-modal__header__close",
    on: {
      "click": _vm.closeTheUserToShowTasks
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), (_vm.theUserToShowTasks) ? _c('UserOverviewTabs', {
    attrs: {
      "user": _vm.theUserToShowTasks,
      "initialView": "tasks",
      "initialIsShowScheduled": false
    }
  }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.isZenExportModal) ? _c('ZenExport', {
    attrs: {
      "schoolId": _vm.schoolId,
      "schoolYearId": _vm.activeSchoolYear.id
    },
    on: {
      "close": function($event) {
        _vm.isZenExportModal = false
      },
      "exported": _vm.onZenExported
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9319a330!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SubjectsDistribution/SubjectsDistribution.vue
// module id = 2061
// module chunks = 1